import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from "@mui/material";
import useGatePass from "../hooks/useGatePass";

const PassTypeDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled} = props;

    const theme = useTheme();

    const {isFetchingPassType, passTypeList, getGatePassPassType} = useGatePass();
    const [passTypesData, setPassTypesData] = useState([]);

    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        getGatePassPassType();
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (passTypeList?.length > 0) {
            const filteredPassTypes = passTypeList?.filter((type) => type !== value);

            setPassTypesData(filteredPassTypes);
        }
    }, [passTypeList, value])


    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }


    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={passTypesData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingPassType}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Pass Type not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select pass type"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {(isFetchingPassType) ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default PassTypeDropdownComponent